import { render, staticRenderFns } from "./appBasicInfo.vue?vue&type=template&id=52c00fd2&scoped=true"
import script from "./appBasicInfo.vue?vue&type=script&lang=js"
export * from "./appBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./appBasicInfo.vue?vue&type=style&index=0&id=52c00fd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c00fd2",
  null
  
)

export default component.exports